var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 48,
    viewBox: "0 0 80 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.1605,
    cy: 17.5063,
    rx: 14.3703,
    ry: 14.321,
    transform: "rotate(90 47.1605 17.5063)",
    fill: "#B5D7FC",
    stroke: "#18181B",
    strokeWidth: 1.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.5184,
    cy: 18.0019,
    rx: 14.3703,
    ry: 14.321,
    transform: "rotate(90 18.5184 18.0019)",
    fill: "#B5D7FC",
    stroke: "#18181B",
    strokeWidth: 1.5
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.8392,
    cy: 31.8767,
    rx: 14.3703,
    ry: 14.321,
    transform: "rotate(90 32.8392 31.8767)",
    fill: "#B4F5DE",
    stroke: "#18181B",
    strokeWidth: 1.5
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.4813,
    cy: 31.8767,
    rx: 14.3703,
    ry: 14.321,
    transform: "rotate(90 61.4813 31.8767)",
    fill: "#B4F5DE",
    stroke: "#18181B",
    strokeWidth: 1.5
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.1605,
    cy: 17.5063,
    rx: 14.3703,
    ry: 14.321,
    transform: "rotate(90 47.1605 17.5063)",
    stroke: "#18181B",
    strokeWidth: 1.5
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.8392,
    cy: 31.8767,
    rx: 14.3703,
    ry: 14.321,
    transform: "rotate(90 32.8392 31.8767)",
    stroke: "#18181B",
    strokeWidth: 1.5
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.4813,
    cy: 31.8767,
    rx: 14.3703,
    ry: 14.321,
    transform: "rotate(90 61.4813 31.8767)",
    stroke: "#18181B",
    strokeWidth: 1.5
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.5184,
    cy: 18.0019,
    rx: 14.3703,
    ry: 14.321,
    transform: "rotate(90 18.5184 18.0019)",
    stroke: "#18181B",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.fd663e995de88151c9f5292552271092.svg";
export { ForwardRef as ReactComponent };